import { Scene, AbstractMesh, WebGPUEngine, ArcRotateCamera, Mesh, NodeMaterial, Color3, DirectionalLight, ExecuteCodeAction, MeshBuilder, ActionManager, TransformNode, PointerEventTypes, PBRMaterial, ShaderMaterial, SimplificationType, Vector3, SpriteManager, Sprite } from '@babylonjs/core';
import { ModelLoader } from './../loader/ModelLoader';
import { BaseStage } from './BaseStage';
import { MockFancilityState } from './MockFancilityState';
import { CsmShadow } from './../materials/shadow/CsmShadow';
import { BabylonTools } from '../utils/BabylonTools';
import { HotPoint } from './../displayObject/UI/HotPoint';
import { FaultPoint } from './../displayObject/UI/FaultPoint';
import { MaintainPoint } from './../displayObject/UI/MaintainPoint';
import { ProcessPoint } from './../displayObject/UI/ProcessPoint';
import { WarnPoint } from './../displayObject/UI/WarnPoint';
import { HoldPoint } from './../displayObject/UI/HoldPoint';
import { ShutdownPoint } from './../displayObject/UI/ShutdownPoint';
import { NaviMinimap } from '../displayObject/UI/NaviMinimap';
import { Menu } from '../displayObject/UI/Menu';
import { FacilityInfo } from '../displayObject/UI/FacilityInfo';
import { GlobalObject } from '../utils/GlobalObject';
import { Boardcaster } from './../event/Boadcaster';
import { CrossEvent } from './../event/CrossEvent';
import { Tool } from './../utils/tools';

export class BirdsEyeStage extends BaseStage {
    protected scene: Scene;
    private temp: any;
    private groundMesh?: AbstractMesh | null;
    private grassMesh?: AbstractMesh | null;
    private boxMesh?: AbstractMesh | null;
    private camMesh?: AbstractMesh | null;
    private treeMesh?: AbstractMesh | null;
    private nearMesh?: AbstractMesh | null;
    private farMesh?: AbstractMesh | null;
    private mountainMesh?: AbstractMesh | null;
    private jingziMesh?: AbstractMesh | null;
    private zhuanziMesh?: AbstractMesh | null;
    private lianheMesh?: AbstractMesh | null;
    private pentuMesh?: AbstractMesh | null;
    private peisongMesh?: AbstractMesh | null;
    private zongzhuangMesh?: AbstractMesh | null;
    private carMesh?: AbstractMesh | null;
    private waterMaterial?: NodeMaterial;
    private waterPlane?: Mesh;
    private csmObj?: CsmShadow;
    private camArr?: Sprite[] = [];
    private nowCamObj?: any;
    private source?: any;
    private mc?: TransformNode;
    private stageShowed: boolean = true;
    private mockFancilityState?: MockFancilityState;
    private minimap?:NaviMinimap;
    private menu?:Menu;
    private facilityInfoBox?:FacilityInfo;
    // 1-漫游视角默认大门视角(-342, 120, 328),[-4.03, 0.98]
    // 2-俯视视角
    // 3-视角1 第一排厂房正中间河边(-20, 120, 32)[-6.26, 0.68]
    // 
    private viewPositions = [new Vector3(0, 0, 0), new Vector3(-342, 120, 328), new Vector3(-130, 280, 70), new Vector3(-20, 120, 32)];
    private viewSetting = [[0, 0], [-4.03, 0.98], [-4.68, 0], [-6.26, 0.68]];
    private limitRange = [[-553, -235], [310, 467]]
    private nowDate: Date = new Date();


    constructor(scene: Scene) {
        super(scene);
        this.scene = scene;
        this.source = GlobalObject.getInstance().main.source.home;
        this.mc = new TransformNode("mc_home", this.scene);
        this.mockFancilityState = new MockFancilityState(); // 生成设备状态数据，放入到 GlobalObject.getInstance().main.fancilityData 里面。
        this.mockFancilityState.updata(); // 从低代码去读取接口数据
        GlobalObject.getInstance().setCamShowed(true);
        this.loadModels();
        this.init();
        this.temp = GlobalObject.getInstance().main.temp as any;
        //consolog dev-tool test
    }
    private init() {
        Boardcaster.getInstance().setStage(this);
        if(GlobalObject.getInstance().main.stageName && GlobalObject.getInstance().main.stageName == ""){
            // 从设备详情进入
        }
        GlobalObject.getInstance().setStageName("BirdsEyeStage");
        this.onViewAngleChanged(1);
        GlobalObject.getInstance().main.skybox?.setOutdoorSkybox();
        GlobalObject.getInstance().setCamSpeed(3); // shift漫游速度
        const player = GlobalObject.getInstance().main.player;
        if (player) {
            (player as any).speedNum = 1;
        }
        const camera = (GlobalObject.getInstance().main.camera as ArcRotateCamera);
        camera.upperRadiusLimit = 1.1 * 120;
        camera.minZ = 1;
        camera.maxZ = 1200000;
        camera.fov = 0.45 * Math.PI;
    }
    private async loadModels() {
        let loader = ModelLoader.instance;
        this.groundMesh = await loader.getModel(this.source.ground);
        this.groundMesh?.setEnabled(this.stageShowed);
        this.grassMesh = await loader.getModel(this.source.grass);
        (this.grassMesh as AbstractMesh).position.set(0, 0.9, 0);
        this.grassMesh?.setEnabled(this.stageShowed);
        this.boxMesh = await loader.getModel(this.source.box, 0);  // boxmesh
        this.boxMesh?.setEnabled(this.stageShowed);
        this.treeMesh = await loader.getModel(this.source.tree);
        this.treeMesh?.setEnabled(this.stageShowed);
        this.nearMesh = await loader.getModel(this.source.near);
        this.nearMesh?.setEnabled(this.stageShowed);
        this.farMesh = await loader.getModel(this.source.far);
        this.farMesh?.setEnabled(this.stageShowed);
        this.mountainMesh = await loader.getModel(this.source.mountain);
        this.mountainMesh?.setEnabled(this.stageShowed);

        this.jingziMesh = await loader.getModel(this.source.jingzi);
        this.jingziMesh?.setEnabled(this.stageShowed);
        this.zhuanziMesh = await loader.getModel(this.source.zhuanzi);
        this.zhuanziMesh?.setEnabled(this.stageShowed);
        this.pentuMesh = await loader.getModel(this.source.pentu);
        this.pentuMesh?.setEnabled(this.stageShowed);
        this.peisongMesh = await loader.getModel(this.source.peisong);
        this.peisongMesh?.setEnabled(this.stageShowed);
        this.zongzhuangMesh = await loader.getModel(this.source.zongzhuang);
        (this.zongzhuangMesh as AbstractMesh).position.set(-113.6, 0, 73.3);
        this.zongzhuangMesh?.setEnabled(this.stageShowed);
        this.carMesh = await loader.getModel(this.source.cars);
        this.carMesh?.setEnabled(this.stageShowed);
        (this.scene.getMaterialByName('branch-01') as PBRMaterial).emissiveColor = new Color3(0.19, 0.39, 0.02);
        (this.scene.getMaterialByName('branch-01') as PBRMaterial).ambientColor = new Color3(0.18, 0.39, 0.02);
        (this.scene.getMaterialByName('branch-02') as PBRMaterial).emissiveColor = new Color3(0.18, 0.29, 0.02);
        (this.scene.getMaterialByName('branch-02') as PBRMaterial).ambientColor = new Color3(0.18, 0.29, 0.02);
        this.camMesh = await loader.getModel(this.source.camMesh);
        this.scene.addMesh(this.camMesh as AbstractMesh);
        this.generateSunLight();

        if (Tool.osType() == 'pc') {
            this.createWaterMaterial();
            this.generateShadow(); // 投影测试
        }
        this.createPhysics();
        this.createCam();
        this.showPoints();
        this.addPickEvent();
        this.initMinimap();
        this.initFacilityInfoBox();
        this.camEanbled(this.stageShowed); // 如果代码运行到这里时，已经切换到其他车间
        this.initMenu();
    }
    private createPhysics() {
        let collider = this.boxMesh?.getChildren()[0];
        // console.log(this.boxMesh?.getChildren());
        collider?.getChildren().forEach((c) => {
            if (c instanceof Mesh) {
                c.checkCollisions = true;
                c.isPickable = false;
            }
        });
        this.scene.addMesh(this.boxMesh as AbstractMesh);
    }
    private async createWaterMaterial() {
        if (GlobalObject.getInstance().main.temp.isWebGPU == true) {
            this.waterMaterial = await NodeMaterial.ParseFromFileAsync("water_09", this.source.waterMaterial, this.scene);
            this.addWaterMaterial();
        }
    }
    private addWaterMaterial() {
        let nodes: Mesh[] = [];
        BabylonTools.flatFromGroup(this.scene.getNodeByName("BP_程序河流_C_0") as TransformNode, nodes);
        BabylonTools.flatFromGroup(this.scene.getNodeByName("BP_程序河流_C_1") as TransformNode, nodes);
        BabylonTools.flatFromGroup(this.scene.getNodeByName("BP_程序河流_C_2") as TransformNode, nodes);
        BabylonTools.flatFromGroup(this.scene.getNodeByName("BP_程序河流_C_3") as TransformNode, nodes);
        //console.log(nodes);
        this.waterPlane = Mesh.MergeMeshes(nodes) as Mesh;
        this.waterPlane.setParent(this.groundMesh as TransformNode);
        this.waterPlane.material = this.waterMaterial as NodeMaterial;
    }
    private async showPoints() {
        let hp = GlobalObject.getInstance().main.HotPoint;
        if (!hp) {
            hp = new HotPoint(this.scene);
            GlobalObject.getInstance().setHotPoint(hp);
        }
        let fp = new FaultPoint(this.scene);
        GlobalObject.getInstance().setFp(fp);
        let mp = new MaintainPoint(this.scene);
        GlobalObject.getInstance().setMp(mp);
        let pp = new ProcessPoint(this.scene);
        GlobalObject.getInstance().setPp(pp);
        let wp = new WarnPoint(this.scene);
        GlobalObject.getInstance().setWp(wp);
        let hop = new HoldPoint(this.scene);
        GlobalObject.getInstance().setHop(hop);
        let sp = new ShutdownPoint(this.scene);
        GlobalObject.getInstance().setSp(sp);

        await hp.init();
        let posArr = [
            new Vector3(-170, 40, 100),
            new Vector3(-300, 28, 30),
            new Vector3(-160, 28, 190),
            new Vector3(82, 28, 130),
            new Vector3(-310, 30, 150),
            new Vector3(-230, 28, -10)
        ];
        for (let i = 0; i < 6; ++i) {
            let point = hp.clone() as any;
            point.name = "ohp_" + i;
            this.scene.addMesh(point);
            point.position = posArr[i];
            hp.addAnimation(point.getChildren()[0] as Mesh);
            point.setParent(this.mc as TransformNode);
        }
    };
    private generateSunLight() {
        let light = new DirectionalLight("sun", new Vector3(-1, -2, -1), this.scene);
        light.position = new Vector3(220, 40, 300);
        light.intensity = 3.5;
        GlobalObject.getInstance().setSunlight(light);
        light.autoCalcShadowZBounds = true;
    }
    private generateShadow() {
        this.csmObj = new CsmShadow(this.scene, GlobalObject.getInstance().main.sunLight);
        GlobalObject.getInstance().setShadow(this.csmObj);
        let g = this.csmObj.getGenerator();
        let casters: Mesh[] = [];
        (this.groundMesh as TransformNode).getChildMeshes().forEach((c) => {
            c.isPickable = false;
            c.receiveShadows = true;
        });
        (this.treeMesh as TransformNode).getChildMeshes().forEach((c) => {
            c.isPickable = false;
            g.addShadowCaster(c);
        });
        (this.jingziMesh as TransformNode).getChildMeshes().forEach((c) => {
            c.isPickable = false;
            g.addShadowCaster(c);
        });
        (this.zhuanziMesh as TransformNode).getChildMeshes().forEach((c) => {
            c.isPickable = false;
            g.addShadowCaster(c);
        });
        (this.pentuMesh as TransformNode).getChildMeshes().forEach((c) => {
            c.isPickable = false;
            g.addShadowCaster(c);
        });
        (this.peisongMesh as TransformNode).getChildMeshes().forEach((c) => {
            c.isPickable = false;
            g.addShadowCaster(c);
        });
        (this.zongzhuangMesh as TransformNode).getChildMeshes().forEach((c) => {
            c.isPickable = false;
            g.addShadowCaster(c);
        });
        (this.farMesh as TransformNode).getChildMeshes().forEach((c) => {
            c.isPickable = false;
            g.addShadowCaster(c);
        });
    }
    private addPickEvent() {
        this.scene.onPointerObservable.add((e) => {
            switch (e.type) {
                case PointerEventTypes.POINTERDOWN: {
                    if (e.pickInfo && e.pickInfo.pickedMesh) {
                        if (e.pickInfo.pickedMesh.parent && e.pickInfo.pickedMesh.parent.name.indexOf('ohp') > -1) {
                            //console.log(e.pickInfo.pickedMesh.name, e.pickInfo.pickedMesh?.parent?.name);
                            if (e.pickInfo.pickedMesh?.parent?.name) {
                                this.changeStage(e.pickInfo.pickedMesh.parent.name);
                            }
                        }
                        // 
                        if (e.pickInfo.pickedMesh.parent && e.pickInfo.pickedMesh.parent.name == 'shiwai') {
                            // console.log(e.pickInfo.pickedMesh.name);
                            this.openCameraVideo(e.pickInfo.pickedMesh.name);
                        }
                    }
                    break;
                }
            }
        });
    }
    private openCameraVideo(name: string) {
        if (this.nowCamObj[name]) {
            let ipStr = this.nowCamObj[name][0];
            let nameStr = this.nowCamObj[name][1];
            let msg = { type: "openCam", data: { name: nameStr, ip: ipStr } }
            Boardcaster.getInstance().send(msg);
        }
    }
    private createCam() {
        this.nowCamObj = GlobalObject.getInstance().main.camData["室外"];
        let spriteManagerCams = new SpriteManager("camManager", this.source.camImg, 600, 512, this.scene); // 最大精灵数量600，精灵单元格的大小
        //spriteManagerCams.isPickable = true;
        let parent = this.scene.getTransformNodeByName('shiwai');
        let m: Mesh[] = parent?.getChildMeshes() as Mesh[];
        m.forEach((c) => {
            if (this.nowCamObj[c.name]) {
                let bboxCenter = c.getBoundingInfo().boundingBox.centerWorld;
                let pos: Vector3 = new Vector3(bboxCenter.x, bboxCenter.y, bboxCenter.z);
                let cam = new Sprite(c.name, spriteManagerCams);
                cam.size = 4;
                cam.position = new Vector3(pos.x, pos.y, pos.z);
                this.camArr?.push(cam);
                /*
                cam.isPickable = true;
                cam.actionManager = new ActionManager(this.scene);
                cam.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickUpTrigger,  (evt)=> {
                    console.log(evt.source);
                    this.openCameraVideo(evt.source.name);
                }));
                */
            }

            c.visibility = 0;
            //c.dispose();
        });
    }
    private camEanbled(showed: boolean) {
        console.log('change cam vasible: ' + showed);
        this.camArr?.forEach((c) => {
            c.isPickable = showed;
            c.isVisible = showed;
        });
    }
    private changeStage(parentName: string) {
        const date: Date = new Date();
        if ((date.getTime() - this.nowDate.getTime()) < 1000) {
            return;
        }
        this.nowDate = date;
        console.log("changeStage and parentName is: " + parentName); // ohp_0 ~ ohp_5
        // 传参给外部
        let num = parentName.substring(4, 5);
        Boardcaster.getInstance().send({ type: "workshopChanged", data: parseInt(num) + 1 });

        // 事件通知给stagemanager切换场景
        const emitter = CrossEvent.getInstance().getEmitter();
        emitter.emit(CrossEvent.getInstance().STAGE_CHANGED, {
            data: parentName,
            descript: "点击了热区模型，跳转到对应场景",
            from: "BirdsEyeStage",
            eventType: "CrossEvent",
        });
    }
    public onViewAngleChanged(data: any, locked: boolean = false) {
        const player = GlobalObject.getInstance().main.player;
        const camera = (GlobalObject.getInstance().main.camera as ArcRotateCamera);
        const idx: number = typeof (data) === 'number' ? data : 1;
        console.log("onViewAngleChanged:" + data + ",id" + idx);
        if (player && player.player && idx < this.viewPositions.length) {
            player.locked = locked;
            const pos = this.viewPositions[idx];
            console.log(pos)
            const seting = this.viewSetting[idx];
            player.player.position.set(pos.x, pos.y, pos.z);
            camera.alpha = seting[0];
            camera.beta = seting[1];
        }
    }
    public onCamChanged(data: any) {
        const camShowed = typeof (data) === 'boolean' ? data : true;
        GlobalObject.getInstance().setCamShowed(camShowed);
        this.camEanbled(GlobalObject.getInstance().main.camShowed as boolean);
    }
    public onWorkshopChanged(idx: number) {
        // idx 0-5--> 0首页 1静子 2转子 3联合 4喷涂 5配送 6总装
        //console.log("data is: " + idx);
        let data = "qwq2x";
        if (idx - 1 >= 0) {
            data = "ohp_" + (idx - 1);
        }
        const emitter = CrossEvent.getInstance().getEmitter();
        emitter.emit(CrossEvent.getInstance().STAGE_CHANGED, {
            data: data,
            descript: "切换场景",
            from: "BirdsEyeStage",
            eventType: "CrossEvent",
        });

    }
    private initMinimap(){
        const camera = (GlobalObject.getInstance().main.camera as ArcRotateCamera);
        this.minimap = NaviMinimap.getInstance(this.scene,camera);
        GlobalObject.getInstance().setMinimap(this.minimap);
    }
    private initMenu(){
        this.menu = Menu.getInstance();
        //this.menu.hide();
    }
    private initFacilityInfoBox(){
        this.facilityInfoBox = FacilityInfo.getInstance();
        GlobalObject.getInstance().setFancilityInfoBox(this.facilityInfoBox);
    }
    public reload() {
        this.stageShowed = true;
        this.groundMesh?.setEnabled(true);
        this.grassMesh?.setEnabled(true);
        this.boxMesh?.setEnabled(true);
        this.mountainMesh?.setEnabled(true);
        this.treeMesh?.setEnabled(true);
        this.nearMesh?.setEnabled(true);
        this.farMesh?.setEnabled(true);
        this.jingziMesh?.setEnabled(true);
        this.zhuanziMesh?.setEnabled(true);
        this.pentuMesh?.setEnabled(true);
        this.peisongMesh?.setEnabled(true);
        this.zongzhuangMesh?.setEnabled(true);
        this.carMesh?.setEnabled(true);
        this.camEanbled(GlobalObject.getInstance().main.camShowed as boolean || true);
        this.mc?.setEnabled(true);
        this.init();
    }
    public unload() {
        this.stageShowed = false;
        this.groundMesh?.setEnabled(false);
        this.grassMesh?.setEnabled(false);
        this.boxMesh?.setEnabled(false);
        this.mountainMesh?.setEnabled(false);
        this.treeMesh?.setEnabled(false);
        this.nearMesh?.setEnabled(false);
        this.farMesh?.setEnabled(false);
        this.jingziMesh?.setEnabled(false);
        this.zhuanziMesh?.setEnabled(false);
        this.pentuMesh?.setEnabled(false);
        this.peisongMesh?.setEnabled(false);
        this.zongzhuangMesh?.setEnabled(false);
        this.carMesh?.setEnabled(false);
        this.camEanbled(false);
        this.mc?.setEnabled(false);
    }
}
